import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=a2139fc0&scoped=true"
import script from "./Layout.vue?vue&type=script&setup=true&lang=js"
export * from "./Layout.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=a2139fc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2139fc0",
  null
  
)

export default component.exports